<template>
  <v-card :class="[$root.isRTL ? 'fullContentRTL' : 'fullContent']">
    <v-toolbar dark color="primary" class="fullToolbar">
      <v-toolbar-title class="white--text" style="font-size: 30px; text-align: right;">
        <i class="material-icons icon">recent_actors</i>לקוחות
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field dark prepend-icon="search" single-line style="padding-top: 20px;" v-model="txtSearch"></v-text-field>
    </v-toolbar>
    <div style="width: 100%;">
      <div style="text-align: right;">
        <v-icon @click="addNew" class="btnAdd" v-tooltip:left="{ html: 'הוסף חדש' }">add</v-icon>
      </div>
      <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
        <tr class="trPrint trHeader">
          <th class="tdData sp">שם לקוח/רוכש</th>
          <th class="tdData">איש קשר</th>
          <th class="tdData">טלפון</th>
          <th class="tdData">חשבון משתמש</th>
          <th class="tdData">יומנים שנרכשו</th>
          <!--<th class="tdData">יומנים בשימוש</th>-->
          <th class="tdCtrl" style="width: 160px!important;"></th>
        </tr>
      </table>
      <div class="scrollContent" v-if="hasData">
        <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1" style="border:none;">
          <tr v-for="row in filteredRows">
            <td class="tdData sp">{{row.FullName}}</td>
            <td class="tdData tdTxt">{{row.ContactPerson}}</td>
            <td class="tdData tdTxt">{{row.Phone}}</td>
            <td class="tdData tdTxt">{{row.Username}}</td>
            <td class="tdData tdTxt">{{row.TotalDiaries}}</td>
            <!--<td class="tdData tdTxt">{{row.UsedDiaries}}</td>-->
            <td class="tdCtrl tdTxt" style="width: 160px!important;">
              <v-icon @click="addDiaries(row)" class="btnIcon mr-2" style="font-size: 34px;" v-tooltip:bottom="{ html: 'הוספת יומנים' }">playlist_add</v-icon>
              <v-icon @click="edit(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'עריכה' }">border_color</v-icon>
              <v-icon @click="confirm(row)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'מחיקה' }">delete</v-icon>
            </td>
          </tr>
        </table>
      </div>
      <div fluid v-else>
        <h3 style="padding-top: 40px;">אין נתונים</h3>
      </div>
      <PopupCustomer></PopupCustomer>
      <PopupAddDiaries></PopupAddDiaries>
    </div>
  </v-card>
</template>

<script>

  import { db } from '../firebase';
  var usersRef = db.ref('Users');
  import PopupCustomer from '../components/PopupCustomer';
  import PopupAddDiaries from '../components/PopupAddDiaries';

  export default {
    name: 'Customers',
    components: { PopupCustomer, PopupAddDiaries },
    data() {
      return {
        txtSearch: '',
        customers: [],
        isActiveUsers: false,
        popup: {
          isVisible: false,
          title: '',
          question: '',
          caller: '',
          isConfirmed: false,
          data: { '.key': '', FullName: '', ContactPerson: '', Phone: '', Username: '', Password: '', TotalDiaries: 0, UsedDiaries: 0 },
        }
      }
    },
    firebase: function () {
      var vm = this;
      return {
        users: usersRef.orderByChild("Type").equalTo("רוכש")
      }
    },
    created() {
      this.$Log("Vue [Customers] is created ...");
    },
    ready() {
      this.$Log("Vue [Customers] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Customers] is mounted ...");
    },
    updated() {
      this.$Log("Vue [Customers] is updated ...");
    },
    computed: {
      hasData() {
        return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
      },
      filteredRows() {
        var vm = this;
        if (vm.txtSearch.length > 0) {
          var result = [];
          try {
            result = vm.users.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                  if (vm.isActiveUsers) {
                    if (row.Active) {
                      return row;
                    }
                  }
                  else {
                    return row;
                  }
                }
              })
            });
          }
          catch (e) {
          }
        }
        else {
          result = vm.users;
        }

        return result;
      }
    },
    watch: {
      '$root.confirm.isConfirmed'(val) {
        if (val && this.$root.confirm.caller == 'RemoveUser') {
          this.remove();
        }
      },
      '$root.confirmAddDiaries.isConfirmed'(val) {
        if (val) {
          let totalDieries = Number(this.$root.confirmAddDiaries.totalDiaries);
          if (this.popup.data.TotalDiaries) {
            totalDieries += Number(this.popup.data.TotalDiaries);
          }
          usersRef.child(this.popup.data['.key']).child("TotalDiaries").set(totalDieries);
        }
      }
    },
    methods: {
      currency(N) {
        N = parseFloat(N);
        if (!isNaN(N))
          N = N.toFixed(2);
        else
          N = '0.00';
        return N + " ₪";
      },
      addNew() {
        this.popup = {
          isVisible: true,
          isEdit: false,
          title: 'לקוח חדש',
          data: { '.key': '', FullName: '', ContactPerson: '', Phone: '', Username: '', Password: '', TotalDiaries: 0, UsedDiaries: 0 }
        };
      },
      addDiaries(row) {
        this.popup.data = row;
        this.$root.confirmAddDiaries = {
          isVisible: true,
          totalDiaries: 1,
          isConfirmed: false
        }
      },
      edit(row) {
        this.popup = {
          isVisible: true,
          isEdit: true,
          title: 'עריכת לקוח',
          data: {
            '.key': row['.key'],
            FullName: row.FullName,
            ContactPerson: row.ContactPerson,
            Phone: row.Phone,
            Username: row.Username,
            Password: row.Password,
            TotalDiaries: row.TotalDiaries,
            UsedDiaries: row.UsedDiaries
          }
        };
      },
      confirm(row) {
        this.popup.data = row;
        this.$root.confirm = {
          isVisible: true,
          title: 'מחיקה',
          question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
          caller: 'RemoveUser',
          isConfirmed: false
        }
      },
      remove() {
        usersRef.child(this.popup.data['.key']).remove();
      },
      insert() {
        //var item = {
        //  FullName: this.popup.data.FullName,
        //  ContactPerson: this.popup.data.ContactPerson,
        //  Phone: this.popup.data.Phone,
        //  Username: this.popup.data.Username,
        //  Password: this.popup.data.Password,
        //  TotalDiaries: 10, //this.popup.data.TotalDiaries,
        //  UsedDiaries: 0, //this.popup.data.UsedDiaries
        //};

        var item = {
          FullName: this.popup.data.FullName,
          ContactPerson: this.popup.data.ContactPerson ? this.popup.data.ContactPerson : '',
          Phone: this.popup.data.Phone ? this.popup.data.Phone : '',
          Username: this.popup.data.Username,
          Identity: this.popup.data.Identity,
          Type: this.popup.data.Type,
          Password: this.popup.data.Password,
          Active: this.popup.data.Active,
          Approved: this.popup.data.Approved,
          TotalDiaries: 10, //this.popup.data.TotalDiaries,
          UsedDiaries: 0, //this.popup.data.UsedDiaries
        };

        usersRef.push(item);
      },
      update() {
        //var item = {
        //  FullName: this.popup.data.FullName,
        //  ContactPerson: this.popup.data.ContactPerson,
        //  Phone: this.popup.data.Phone,
        //  Username: this.popup.data.Username,
        //  Password: this.popup.data.Password,
        //  TotalDiaries: 10, //this.popup.data.TotalDiaries,
        //  UsedDiaries: 0, //this.popup.data.UsedDiaries
        //};

        var item = {
          FullName: this.popup.data.FullName,
          ContactPerson: 'ttt', //this.popup.data.ContactPerson ? this.popup.data.ContactPerson : '',
          Phone: 'ttt', //this.popup.data.Phone ? this.popup.data.Phone : '',
          Username: this.popup.data.Username,
          Identity: this.popup.data.Identity,
          Type: this.popup.data.Type,
          Password: this.popup.data.Password,
          Active: this.popup.data.Active,
          Approved: this.popup.data.Approved,
          TotalDiaries: 10, //this.popup.data.TotalDiaries,
          UsedDiaries: 0, //this.popup.data.UsedDiaries
        };

        usersRef.child(this.popup.data['.key']).set(item);
      }
    }
  }

</script>
<style></style>



// WEBPACK FOOTER //
// Customers.vue?5a074334